<template>
    <div class="section-success" v-if="state.show">
        <div class="container">
            <div class="section-success__inner flex v-center">
                <div class="section-success__body">
                    <div class="section-success__icon">
                        <img src="/local/templates/main/img/icons/icon-success-section.svg" alt="">
                    </div>
                    <div class="section-success__title">Спасибо за просмотр!</div>
                    <div class="section-success__desc">Мы в скором времени свяжимся с вами для согласования всех деталей мероприятия</div>
                    <ABtn label="Вернуться на сайт" :href="params.url" class="primary section-success__btn" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { ABtn } from '../ui'

export default {
    name: 'SuccessSection',
    props: ['params'],
    components: {
        ABtn,
    },
    setup: (props, ctx) => {

        const state = ref({
            show: props.params.show,
        })
        return {
            state
        }
    },
}
</script>

<style lang="scss">
    .section-success {
        &__inner {
            min-height: 100vh;
            width: 100%;
            justify-content: center;
            background: #fff;
        }
        &__body {
            text-align: center;
        }
        &__icon {
            img {
                width: 119px;
                height: 119px;
            }
        }
        &__title {
            margin-top: 28px;
            font-family: var(--font-secondary);
            font-weight: 600;
            font-size: 48px;
            line-height: 58px;
            @include tablet {
                font-size: 22px;
                line-height: 28px;
            }
        }
        &__desc {
            margin: 10px auto 0 auto;
            font-size: 18px;
            line-height: 28px;
            color: var(--c-gray-300);
            max-width: 430px;
            @include tablet {
                font-size: 14px;
                line-height: 20px;
            }
        }
        &__btn {
            margin-top: 48px;
            @include tablet {
                margin-top: 35px;
            }
            @include mobile {
                margin-top: 15px;
            }
        }
    }
</style>
